import Script from 'next/script';

import type { JSX } from "react";

declare const dataLayer: Array<unknown> | undefined;
interface EventPayload {
  event: string;
  conversionValue?: number;
}

export const trackEvent = (payload: EventPayload): void => {
  if (typeof dataLayer === 'undefined') {
    console.info('trackEvent', payload);
    return;
  }

  dataLayer?.push(payload);
};

export const trackLeadData = (data: Partial<{
  email: string;
  phone: string;
  firstName: string;
  lastName: string;
}>) => {
  const payload = {
    leadData: data,
  };

  if (typeof dataLayer === 'undefined') {
    console.info('trackLeadData', payload);
    return;
  }

  dataLayer.push(payload);
};

const GoogleTagManager = (): JSX.Element | null => {
  const gtmId = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;
  if (!gtmId) { return null; }

  return (
    <Script id="google-tag-manager" strategy="lazyOnload">
      {`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer', '${gtmId}');
      `}
    </Script>
  );
};

export default GoogleTagManager;
